class OffCanvasMenu extends HTMLElement {
  constructor() {
    super();

    this.classNames = {
      menuParent: 'offcanvas-canvas',
      menuLeft: 'offcanvas--left',
      menuPush: 'offcanvas--push',
      menuFilter: 'offcanvas--filter',
      menuStepOne: 'menu-step-1',
      menuStepTwo: 'menu-step-2',
      navStepTwo: 'nav-step-2',
      triggerStep: 'js-trigger-step',
      backEl: 'js-back-menu',
      closeEl: 'offcanvas__close',
      isOpen: 'is-offcanvas-open',
      isPush: 'is-offcanvas-push',
      isFilter: 'is-offcanvas-filter',
      isPushLeft: 'is-offcanvas-push-left',
      smoothScroll: 'scroll-behavior-smooth',
      desktopNavLinksBlack: 'search-menu-open',
      searchSidebar: 'offcanvas-instance-search-sidebar'
    };

    // move menu into the root parent element (where it needs to be for "push"
    // effect) if not already there this allows menus to be included outside
    // theme.liquid and use section data as needed
    const menuParentEl = document.querySelector(
      `.${this.classNames.menuParent}`
    );
    if (menuParentEl && this.parentElement !== menuParentEl) {
      menuParentEl.appendChild(this);
    }

    this.hidden = true;
    this.addDimmer();
    this.initControls();
    this.smoothScroll = document.documentElement.classList.contains(
      this.classNames.smoothScroll
    );
  }

  /**
   *
   * @param {0 | 1} index
   */
  activateStepPanels = (index, event) => {
    let menuKey = null;

    if (event) {
      menuKey = event.currentTarget.dataset?.menu;
    }
    const elStepOne = this.querySelector(`.${this.classNames.menuStepOne}`);
    const elStepTwo = this.querySelector(`.${this.classNames.menuStepTwo}`);
    const elClose = this.querySelector(`.${this.classNames.closeEl}`);
    const elBack = this.querySelector(`.${this.classNames.backEl}`);

    elClose?.classList.toggle('active', index === 0);
    elBack?.classList.toggle('active', index !== 0);

    elStepOne?.classList.toggle('active', index === 0);
    elStepTwo?.classList.toggle('active', index === 1);
    elStepTwo
      ?.querySelectorAll(''.concat('.', this.classNames.navStepTwo ?? ''))
      .forEach(el => {
        const navMenuKey = el.dataset?.menu;
        el.classList.toggle('active', navMenuKey === menuKey);
      });
  };

  handleBack = () => this.activateStepPanels(0);

  connectedCallback() {
    this.eventListenersMap = new Map();
    // The mobile menu offcanvas variant has a 2 step modal
    this.isMobileMenu = this.id === 'mobile-menu';
    if (this.isMobileMenu) {
      this.querySelector(`.${this.classNames.backEl}`)?.addEventListener(
        'click',
        this.handleBack
      );

      this.querySelectorAll(
        ''.concat('.', this.classNames.triggerStep ?? '')
      ).forEach(btn => {
        const listener = event => this.activateStepPanels(1, event);
        btn.addEventListener('click', listener);
        this.eventListenersMap.set(btn, listener);
      });
    }
  }

  disconnectedCallback() {
    this.querySelector(`.${this.classNames.backEl}`)?.removeEventListener(
      'click',
      this.handleBack
    );

    this.eventListenersMap?.forEach(btn => {
      const listener = this.eventListenersMap.get(btn);
      if (listener) {
        btn.removeEventListener('click', listener);
      }
    });
    this.eventListenersMap.clear();
  }

  initControls() {
    this.addEventListener(
      'keyup',
      evt => evt.code === 'Escape' && this.close()
    );

    this.closeButtons = this.querySelectorAll('button[name="close"]');
    this.closeButtons.forEach(b =>
      b.addEventListener('click', this.close.bind(this))
    );

    this.toggleButtons = document.querySelectorAll(
      `a[href="#${this.id}"], [data-menu-toggle="${this.id}"]`
    );

    this.toggleButtons.forEach(t => {
      t.addEventListener('click', e => {
        e.preventDefault();

        let btn = e.target;
        if (btn.tagName !== 'A' || btn.tagName !== 'BUTTON')
          btn = e.target.closest('a, button');
        const menuToggle = btn.dataset.menuToggle;

        if (
          (menuToggle === 'account-drawer' || menuToggle === 'mini-cart') &&
          btn.id != 'cart-icon-bubble'
        ) {
          [...document.querySelectorAll('offcanvas-menu')].forEach(menu =>
            menu.classList.add('disable-anim')
          );
        }
        this.toggle();
        if (
          (menuToggle === 'account-drawer' || menuToggle === 'mini-cart') &&
          btn.id != 'cart-icon-bubble'
        ) {
          setTimeout(() => {
            [...document.querySelectorAll('offcanvas-menu')].forEach(menu =>
              menu.classList.remove('disable-anim')
            );
          }, 300);
        }
      });
    });
  }

  toggleSmoothScroll() {
    if (this.smoothScroll) {
      document.documentElement.classList.toggle(this.classNames.smoothScroll);
    }
  }

  toggleSmoothScroll() {
    if (this.smoothScroll) {
      document.documentElement.classList.toggle(this.classNames.smoothScroll);
    }
  }

  open() {
    if (this.isMobileMenu) {
      this.activateStepPanels(0);
    }

    let openClasses = [this.classNames.isOpen];

    if (this.id.indexOf('search-sidebar') > -1) {
      openClasses.push(this.classNames.searchSidebar);
    }

    if (this.id.indexOf('search-sidebar') > -1 && window.innerWidth >= 1250) {
      openClasses.push(this.classNames.desktopNavLinksBlack);
    }

    if (this.id.indexOf('search-sidebar') > -1 && window.innerWidth < 1250) {
      document.querySelector('#search-sidebar').style.height =
        window.innerHeight + 'px';
    } else {
      document.querySelector('#search-sidebar').style.height = 'auto';
    }

    if (!this.hidden) {
      return;
    }

    window.theme?.noscroll?.apply();

    this.toggleSmoothScroll();

    if (this.classList.contains(this.classNames.menuPush)) {
      if (this.id.indexOf('search-sidebar') > -1 && window.innerWidth < 1250) {
        openClasses.push(this.classNames.isPush);
      } else if (this.id.indexOf('search-sidebar') < 0) {
        openClasses.push(this.classNames.isPush);
      }
      if (this.classList.contains(this.classNames.menuFilter)) {
        openClasses.push(this.classNames.isFilter);
      }
      if (this.classList.contains(this.classNames.menuLeft)) {
        openClasses.push(this.classNames.isPushLeft);
      }
    }

    if (this.style.transition !== '') {
      this.addEventListener(
        'transitionend',
        () => {
          this.focus();
          trapFocus(this);
        },
        { once: true }
      );
    } else {
      this.focus();
      trapFocus(this);
    }

    this.dimmer.hidden = false;
    this.hidden = false;

    window.requestAnimationFrame(() => {
      this.classList.add('is-active');
      document.body.classList.add(...openClasses);
    });
  }

  close() {
    if (this.hidden) {
      return;
    }

    if (this.isMobileMenu) {
      this.activateStepPanels(0);
    }

    window.theme?.noscroll?.remove();
    this.toggleSmoothScroll();

    this.toggleSmoothScroll();

    document.body.classList.remove(
      this.classNames.isOpen,
      this.classNames.isPush,
      this.classNames.isPushLeft,
      this.classNames.isFilter,
      this.classNames.desktopNavLinksBlack,
      this.classNames.searchSidebar
    );

    if (this.style.transition !== '') {
      this.addEventListener(
        'transitionend',
        () => {
          this.hidden = true;
          this.dimmer.hidden = true;
          removeTrapFocus(this.activeElement);
        },
        { once: true }
      );
    } else {
      this.hidden = true;
      this.dimmer.hidden = true;
      removeTrapFocus(this.activeElement);
    }

    this.classList.remove('is-active');

    document.querySelector('.mini-cart-add-error')?.classList.add('hidden');
    document.querySelector('.mini-cart-quantity-limit-error')?.classList.add('hidden');
  }

  toggle() {
    if (this.hidden) {
      this.closeAllMenus();
      this.open();
    } else {
      this.close();
    }
  }

  addDimmer() {
    this.dimmer = document.querySelector('.offcanvas-dimmer');
    if (this.dimmer) {
      return;
    }
    this.dimmer = document.createElement('div');
    this.dimmer.classList.add('offcanvas-dimmer');
    document.body.appendChild(this.dimmer);
    this.dimmer.addEventListener('click', this.closeAllMenus);
  }

  closeAllMenus() {
    document.querySelectorAll('offcanvas-menu').forEach(menu => {
      menu.close();
    });
  }
}

customElements.define('offcanvas-menu', OffCanvasMenu);
